// extracted by mini-css-extract-plugin
export default {"address":"qYOLw","address__street":"ZJR8l","address__house":"rCgwE","address__flat":"MRflo"};